import { useContext } from 'react'
import { useRouter } from 'next/router'
import Link from '../elements/link'
import GlobalContext from '../../global'

const FloatingButton = () => {
  const global = useContext(GlobalContext)
  const router = useRouter()

  return global.data.hotels_page.uid !== router.query.page ? (
    <>
      {global.data.hotels_page.slug ? (
        <Link type="internal" route={`/${global.data.hotels_page.slug}`}>
          <a className="floating-button">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 17 17">
              <path d="M5.58 9.6v6.34M5.58 13.58h14.33M5.57 12.21s.45-.87 2.14-.87 2.11.87 2.11.87.64-1.27 5.09-1.27c3.75 0 5 1.27 5 1.27M9.82 12.16l-.01 1.38M19.91 10.62v5.32" />
            </svg>

            {global.data.hotel_booking_label && <span>{global.data.hotel_booking_label}</span>}
          </a>
        </Link>
      ) : (
        <a className="floating-button" href={global.data.hotels_page.url}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 17 17">
            <path d="M5.58 9.6v6.34M5.58 13.58h14.33M5.57 12.21s.45-.87 2.14-.87 2.11.87 2.11.87.64-1.27 5.09-1.27c3.75 0 5 1.27 5 1.27M9.82 12.16l-.01 1.38M19.91 10.62v5.32" />
          </svg>

          {global.data.hotel_booking_label && <span>{global.data.hotel_booking_label}</span>}
        </a>
      )}
    </>
  ) : null
}

export default FloatingButton
